import api from './apiClient';
import type { ApiResponse } from 'shared/types/api';

export interface QuickLink {
  label: string;
  path: string;
}

export const QUICK_LINKS_MAX = 7;

export const quickLinksApi = {
  get: async (): Promise<QuickLink[]> => {
    const res = await api.get<ApiResponse<{ quickLinks: QuickLink[] }>>('/users/me/quick-links');
    return res.data?.quickLinks || [];
  },
  /** Replace the whole list. Server caps at 7 — extra entries are dropped. */
  update: async (quickLinks: QuickLink[]): Promise<QuickLink[]> => {
    const res = await api.put<ApiResponse<{ quickLinks: QuickLink[] }>>('/users/me/quick-links', { quickLinks });
    return res.data?.quickLinks || [];
  },
};
